function isLocalHostname(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname.startsWith("[") ||
    /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)
  );
}

export function toSiteUrl(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }
  try {
    const hasScheme = /^https?:\/\//i.test(trimmed);
    const url = new URL(hasScheme ? trimmed : `https://${trimmed}`);
    if (!url.hostname.includes(".") && !isLocalHostname(url.hostname)) {
      return null;
    }
    if (!hasScheme && isLocalHostname(url.hostname)) {
      url.protocol = "http:";
    }
    return url.toString();
  } catch {
    return null;
  }
}
